import { Handshake, KeyRound, Megaphone } from "lucide-react";
import { FadeUp, SectionHead } from "./Reveal";

const SERVICES = [
  {
    n: "01",
    icon: Megaphone,
    title: "التسويق العقاري",
    text: "تسويق العقارات والوصول إلى العملاء المهتمين بطريقة احترافية تُظهر عقارك بأفضل صورة.",
  },
  {
    n: "02",
    icon: Handshake,
    title: "الوساطة العقارية",
    text: "الربط بين أطراف الصفقة والمساعدة في تسهيل الإجراءات حتى تتم بسلاسة وثقة.",
  },
  {
    n: "03",
    icon: KeyRound,
    title: "التأجير للغير",
    text: "المساعدة في تسويق وتأجير العقارات للمالكين، من العرض حتى إتمام التعاقد.",
  },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="bg-navy py-24 md:py-36">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <SectionHead dark eyebrow="OUR SERVICES" eyebrowAr="خدمات شيادن" title="ثلاث خدمات، هدف واحد: قرار عقاري سليم" testId="services-heading" />

        <div className="grid gap-6 md:grid-cols-3 md:gap-8">
          {SERVICES.map((s, i) => (
            <FadeUp key={s.n} delay={i * 0.14} className="h-full">
              <article
                data-testid={`service-card-${i + 1}`}
                className="group relative flex h-full flex-col border border-white/10 p-8 transition-[border-color,transform] duration-500 hover:-translate-y-2 hover:border-copper/60 md:p-10"
              >
                <span className="font-display text-5xl md:text-6xl font-semibold text-white/10 transition-colors duration-500 group-hover:text-copper/40">
                  {s.n}
                </span>
                <s.icon
                  className="mt-8 h-9 w-9 text-copper transition-transform duration-500 group-hover:scale-110"
                  strokeWidth={1.5}
                />
                <h3 className="mt-6 font-head text-2xl font-bold text-cream">{s.title}</h3>
                <p className="mt-4 flex-1 text-sm md:text-base leading-relaxed text-cream/60">
                  {s.text}
                </p>
                <span className="rule-copper mt-8 block w-0 transition-[width] duration-700 group-hover:w-24" />
              </article>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
